import {notification} from "antd";

export const PopNotification = (type: string, description: string) => {
    // @ts-ignore
    notification[type]({
        message: type === 'success' ? 'Success' : 'Error',
        description: description,
    });
};